import React from 'react';
import { WifiOff, Heart, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useOrganizationBranding } from '@/hooks/useOrganizationBranding';
import { useLocalization } from '@/hooks/useLocalization';
import { buildPath } from '@/lib/basePath';

export function OfflinePage() {
  const { name: orgName } = useOrganizationBranding();
  const { t } = useLocalization();

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleGoOnline = () => {
    if (navigator.onLine) {
      window.location.href = buildPath('/');
    } else {
      // Show connection tips
      alert(t('portal.offline.checkConnectionAlert'));
    }
  };

  return (
    <div className="min-h-screen bg-gradient-elegant flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 p-3 rounded-full bg-primary/10">
            <WifiOff className="h-8 w-8 text-primary" />
          </div>
          <CardTitle className="flex items-center justify-center gap-2">
            <Heart className="h-5 w-5 text-primary" />
            {orgName} Portal
          </CardTitle>
          <CardDescription>
            {t('portal.offline.title')}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-muted-foreground">
            <p>{t('portal.offline.description1')}</p>
            <p className="mt-2">{t('portal.offline.description2')}</p>
          </div>
          
          <div className="space-y-2">
            <Button 
              onClick={handleGoOnline} 
              className="w-full"
              disabled={!navigator.onLine}
            >
              {t('portal.offline.goToPortal')}
            </Button>
            <Button 
              variant="outline" 
              onClick={handleRefresh}
              className="w-full"
            >
              <RefreshCw className="mr-2 h-4 w-4" />
              {t('portal.offline.checkConnection')}
            </Button>
          </div>

          <div className="text-xs text-center text-muted-foreground mt-6">
            <p>{t('portal.offline.comingSoon')}</p>
            <ul className="mt-1 space-y-1">
              <li>{t('portal.offline.featureAppointments')}</li>
              <li>{t('portal.offline.featurePhotos')}</li>
              <li>{t('portal.offline.featureHelp')}</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
